<template>
  <div class="reportforrepair">
    <div class="header">
      <div class="title">多渠道报事报修</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <img :src="mobilereportforrepair1" alt="" />
      </div>
      <div class="right">
        <div class="item" v-for="item in reportforrepairList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilereportforrepair1 from "../../../../assets/product/mobilereportforrepair1.png";

export default {
  setup() {
    return reactive({
      mobilereportforrepair1: mobilereportforrepair1,
      reportforrepairList: [
        {
          id: 1,
          title: "业主线上报修",
          text: "业主发现问题，通过业主端APP、公众号、小程序等多种渠道提交申请，一键报修，省时省力。",
        },
        {
          id: 2,
          title: "员工内部下单",
          text: "内部员工通过员工专用APP提交申请，一键报事提单，方便快捷。",
        },
        {
          id: 3,
          title: "线上客服下单",
          text: "业主发现问题，可直接拨打客服热线，在线沟通，客服直接下单。",
        },
        {
          id: 4,
          title: "线下下单",
          text: "业主线下扫描二维码，当场提交申请，进行报事报修。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.reportforrepair {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .left img {
  width: 343px;
}

.body .right .item {
  margin-top: 12px;
  text-align: left;
  font-size: 14px;
}
.body .right .item .title {
  font-weight: 600;
}
.body .right .item .text {
  font-size: 12px;
  margin-top: 8px;
  color: #3d3d3d;
}
</style>
